import { shippingOptionContentWidgetSchema } from "@redotech/redo-model/checkouts/checkout-widget";
import * as z from "zod/v4";

export const getShippingOptionWidgets = {
  name: "getShippingOptionWidgets" as const,
  input: z.void(),
  output: z.array(shippingOptionContentWidgetSchema),
};
